import { AlertController, NavController, ToastController } from 'ionic-angular';
import { ActionSheetController } from 'ionic-angular';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AuthProvider } from '../../providers/auth/auth';
import { Condominium, User, CondominiumUserRole, UIStrings } from '../../models/models';
import { CondominiumProvider } from '../../providers/condominium/condominium';

import { CondominiumEditPage } from '../../pages/condominium-edit/condominium-edit';
import { CondominiumShowPage } from '../../pages/condominium-show/condominium-show';
import { MessageCreatePage } from '../../pages/message-create/message-create';


/**
* Generated class for the CondominiumItemComponent component.
*
* See https://angular.io/api/core/Component for more info on Angular
* Components.
*/
@Component({
	selector: 'condominium-item',
	templateUrl: 'condominium-item.html'
})
export class CondominiumItemComponent {
	@Output() refresh: EventEmitter<Condominium> = new EventEmitter<Condominium>();

	private _condominium: Condominium;
	/**
	Eventuale utente di cui si visualizza il condominio
	*/
	@Input() public user: User;

	/*
	eventuale ruolo disassociabile
	*/
	@Input() public role: CondominiumUserRole;

	@Input() isMenuVisible: boolean = true;

	public isExpanded: boolean = false;

	private roleNames = {
		is_administrator: 'Amministratore',
		is_heatingreader: 'Letturista',
		is_worker: 'Addetto',
	};

	constructor(
		public actionSheetCtrl: ActionSheetController,
		public alertCtrl: AlertController,
		public auth: AuthProvider,
		public nav: NavController,
		public toastCtrl: ToastController,
		public condominiums: CondominiumProvider,
	) {
	}


	@Input() public set condominium(condominium: Condominium) {
		this._condominium = condominium;
		console.log('CondominiumItem, condominium:', condominium);
	}
	public get condominium() {
		return this._condominium;
	}

	get isEditable(): boolean {
		return this.auth.canCondominiumEdit(this.condominium)
	}

	get isShowable(): boolean {
		return this.auth.canCondominiumShow(this.condominium)
	}

	/*
	solo superuser possono eliminare i condomini
	*/
	get isDeletable(): boolean {
		return this.auth.canCondominiumDelete(this.condominium)
	}

	/*
	rimuove utenti dal condominio: Solo superuser e amministratori del condominio
	*/
	get isRemovable(): boolean {
		return this.auth.canCondominiumRoleRemove(this.condominium, this.role)
	}

	public click() {
		if (this.isShowable) {
			this.goToCondominiumShow()
		}
	}

	public goToCondominiumEdit() {
		this.nav.push(CondominiumEditPage, { condominium: this.condominium });
	}

	public goToCondominiumShow() {
		this.nav.push(CondominiumShowPage, { condominium: this.condominium });
	}

	public goToMessageCreate() {
		this.nav.push(MessageCreatePage, {
			condominium: this.condominium
		});
	}

	public showMenu(event) {
		event.stopPropagation();

		let role = 'RUOLO INDEFINITO';//in teoria mai: o ha il valore o non visualizza il bottone
		switch (this.role) {
			case 'is_heatingreader':
				role = 'termoletturista';
				break;
			case 'is_worker':
				role = 'addetto';
				break;
		}

		let self = this;
		let buttons = [];
		if (this.isShowable) {
			buttons.push({
				text: UIStrings.SHOW,
				icon: 'eye',
				handler: () => {
					self.goToCondominiumShow();
				}
			});
		}

		if (this.auth.canCondominiumEdit(this.condominium)) {
			buttons.push({
				text: 'Invia messaggio alla bacheca',
				icon: 'text',
				handler: () => {
					self.goToMessageCreate();
				}
			});

			if (this.auth.hasRole('is_admin')) {
				//solo admin può fare edit diretto

				buttons.push({
					text: UIStrings.EDIT,
					role: 'destructive',
					icon: 'create',
					handler: () => {
						self.goToCondominiumEdit();
					}
				});
			}
		}

		if (this.isRemovable) {
			buttons.push({
				text: 'Rimuovi ' + role,
				role: 'destructive',
				icon: 'remove',
				handler: () => {
					self.showRemoveRoleConfirm();
				}
			});
		}
		if (this.isDeletable) {
			buttons.push({
				text: UIStrings.DELETE,
				role: 'destructive',
				icon: 'trash',
				handler: () => {
					self.showDestroyCondominiumConfirm();
				}
			});
		}
		buttons.push({
			text: UIStrings.MENU_CLOSE,
			role: 'cancel',
			icon: 'undo',
			handler: () => { }
		});

		let options = {
			title: 'Condominio "' + this.condominium.name + '"',
			subTitle: this.condominium.housing_units.length + " unità immobiliari",
			buttons: buttons
		};

		if (this.condominium.address) {
			options.subTitle += "\n " + this.condominium.address.formatted;
		}

		let actionSheet = this.actionSheetCtrl.create(options);
		actionSheet.present();

		//this.isExpanded=!this.isExpanded;
	}

	public showDestroyCondominiumConfirm(closable: any = null) {
		if (closable) {
			closable.close();
		}
		let self = this;
		let condominium = this.condominium;

		let confirm = this.alertCtrl.create({
			title: "Eliminare il condominio dal server?",
			message: "Vuoi davvero eliminare il condominio " + condominium.name + (condominium.address ? "' di " + condominium.address.formatted : '') + "?",
			buttons: [
				{
					text: UIStrings.DIALOG_CANCEL,
					role: 'cancel'
				}, {
					text: 'Elimina',
					handler: () => {
						self.condominiums.destroy(condominium).then((success: boolean) => {
							if (success) {
								let toast = self.toastCtrl.create({
									message: 'Condominio eliminato',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								});
								toast.present();
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore eliminando il condominio",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
							}
							self.refresh.emit(condominium);
						}).catch(error => {
							console.error("Errore eliminando il condominio", error);
							let toast = self.toastCtrl.create({
								message: "Errore eliminando il condominio",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							});
							toast.present();
							self.refresh.emit(condominium);
						});
					}
				}
			]
		});
		confirm.present();
	}

	public showRemoveRoleConfirm(closable: any = null) {
		if (closable) {
			closable.close();
		}
		let self = this;
		let condominium = this.condominium;
		let role = this.role;

		let roleName = this.roleNames[role];

		let confirm = this.alertCtrl.create({
			title: "Rimuovere il ruolo dell'utente dal condominio?",
			message: "Vuoi davvero rimuovere il ruolo '" + roleName + "' dal condominio " + condominium.name + "' di " + condominium.address.formatted + "?",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Rimuovi',
					handler: () => {
						condominium[role] = false;
						self.condominiums.update(condominium).then((condominium: Condominium) => {
							if (condominium && !condominium[role]) {
								let toast = self.toastCtrl.create({
									message: 'Ruolo rimosso',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								});
								toast.present();
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore rimuovendo il ruolo",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
							}
							self.refresh.emit(condominium);
						}).catch(error => {
							console.error("Errore rimuovendo il ruolo", error);
							let toast = self.toastCtrl.create({
								message: "Errore rimuovendo il ruolo",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							});
							toast.present();
							self.refresh.emit(condominium);
						});
					}
				}
			]
		});
		confirm.present();
	}
}



// WEBPACK FOOTER //
// ./src/components/condominium-item/condominium-item.ts